export { default as AnnotationSolidIcon } from './AnnotationSolidIcon';
